import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import AddTerminalForm from "../../components/AddTerminalForm/AddTerminalForm";
import Layout from "../../components/shared/Layout/Layout";

const AddTerminalPage = ({ grades, getGradeList }) => {
  useEffect(() => {
    if (grades === null) {
      getGradeList();
    }
  }, [grades, getGradeList]);

  return (
    <div className="bg_light">
      <Layout title="Add Terminal Assessment">
        <AddTerminalForm />
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

const mapDispatchToProps = {
  getGradeList,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddTerminalPage);
